import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GenericCrudService } from './generic-crud.service';
import { AirportRemarks } from '../model/airportRemarks';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class AirportRemarksService extends GenericCrudService<AirportRemarks> {
  constructor(http: HttpClient, config: ConfigService) {
    const urlService = config.values.api_url + 'api/v_5010Web_AirportRemarks';
    super(http, urlService);
  }
}
